const EmailIcon = ({ size = 18 }) => (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={1.8} strokeLinecap='round' strokeLinejoin='round' style={{ flexShrink: 0 }}>
        <rect x='2' y='4' width='20' height='16' rx='2' />
        <path d='M2 7l10 7 10-7' />
    </svg>
);

export default EmailIcon;
